import PlusIcon from '@heroicons/react/outline/PlusIcon'

import { Image } from '@tribeplatform/gql-client/types'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'
import { Card } from '@tribeplatform/react-ui-kit/Card'

export const CreateAppCard = () => {
  const { data: network } = useNetwork()
  return (
    <a
      href="https://partners.tribe.so"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Card className="h-full">
        <Card.Content>
          <div className="flex flex-col space-y-5 h-full">
            {(network?.favicon as Image)?.urls?.small ? (
              <Avatar
                size="md"
                rounded="md"
                name={network?.name}
                src={(network?.favicon as Image)?.urls?.small}
              />
            ) : (
              <div className="flex justify-center items-center bg-surface-200 rounded-md w-10 h-10">
                <PlusIcon className="w-6 h-6" />
              </div>
            )}
            <h4>Build your own app</h4>
            <p>
              Extend the capability of the community with custom functionalities
              using Tribe&apos;s GraphQL API, webhooks, and Liquid template
              engine.
            </p>
          </div>
        </Card.Content>
      </Card>
    </a>
  )
}
